import styled from 'styled-components'
// icons
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
// themes
import { colors } from 'themes'

// Laid out as the ErrorBoundary fallback
export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 24px;
  text-align: center;
`

export const Icon = styled(ErrorOutlineIcon)`
  && {
    color: ${colors.purple300};
    font-size: 96px;
    margin-bottom: 16px;
  }
`

export const Title = styled.div`
  color: ${colors.gray850};
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 8px;
`

export const Text = styled.div`
  color: ${colors.gray400};
  font-size: 16px;
  margin-bottom: 24px;
  max-width: 480px;
`
